import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';
import { isInvalid, isSubmitting, submit } from 'redux-form';

import type { Dispatch, State } from '../../../types';
import { showNotification } from '../../actions/notificationActions';
import { putPOI, showDeletePOIDialog } from '../../actions/poiActions';
import { Routing } from '../../app/Routing';
import type { FunctionProperties, NonFunctionProperties } from '../../utils/typescriptutils/typeManipulation';
import { POISidebar, type POISidebarProps } from './POISidebar';
import { poiFormElements } from './PoiForm';

export const mapStateToProps = (state: State): NonFunctionProperties<POISidebarProps> => {
    const invalid = isInvalid(poiFormElements.formName)(state);
    const submitting = isSubmitting(poiFormElements.formName)(state);
    return {
        mode: 'UPDATE',
        submitDisabled: invalid || submitting,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch): FunctionProperties<POISidebarProps> => ({
    onDelete: (poiId: string) => dispatch(showDeletePOIDialog(poiId)),
    onSubmitForm: (navigate: NavigateFunction) =>
        dispatch(putPOI())
            .then(() => dispatch(showNotification('intl-msg:poi.edit.successNotification', 'success')))
            .then(() => navigate(Routing.poiList))
            .catch(() => dispatch(showNotification('intl-msg:poi.edit.errorNotification', 'error'))),
    onClickSubmit: () => dispatch(submit(poiFormElements.formName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(POISidebar);
